<template lang="pug">
.date-range-wrapper
  v-col(
    :class="startClasses",
    v-bind="startColProps"
  )
    v-text-field(
      dense,
      outlined,
      type="date",
      :label="startLabel",
      :value="startValue",
      :rules="rules",
      :max="maxDate",
      hide-details,
      @input="$emit('update:startValue', $event)"
    )

  v-col(
    :class="endClasses",
    v-bind="endColProps"
  )
    v-text-field(
      dense,
      outlined,
      type="date",
      :label="endLabel",
      :value="endValue",
      :rules="rules",
      :max="maxDate",
      hide-details,
      @input="$emit('update:endValue', $event)"
    )
</template>

<script>
const DEFAULT_COL_PROPS = {
  cols: "12",
  sm: "6",
  md: "auto"
};

export default {
  name: "DateRange",

  props: {
    startValue: {
      type: String,
      default: ""
    },
    endValue: {
      type: String,
      default: ""
    },
    maxDate: {
      type: String,
      default: ""
    },
    rules: {
      type: Array,
      default: () => []
    },
    startLabel: {
      type: String,
      default: "Data inicial"
    },
    endLabel: {
      type: String,
      default: "Data final"
    },
    colClass: {
      type: [String, Array, Object],
      default: ""
    },
    startColClass: {
      type: [String, Array, Object],
      default: ""
    },
    endColClass: {
      type: [String, Array, Object],
      default: ""
    },
    startColProps: {
      type: Object,
      default: () => ({ ...DEFAULT_COL_PROPS })
    },
    endColProps: {
      type: Object,
      default: () => ({ ...DEFAULT_COL_PROPS })
    }
  },

  computed: {
    startClasses() {
      return ["date-range__col", "date-range__col--start", this.colClass, this.startColClass];
    },

    endClasses() {
      return ["date-range__col", "date-range__col--end", this.colClass, this.endColClass];
    }
  }
};
</script>

<style scoped>
.date-range-wrapper {
  display: contents;
}

.date-range__col {
  padding: 6px !important;
}

.date-range__col .v-input {
  width: 100%;
}

.date-range__col--start,
.date-range__col--end {
  flex: 0 0 228px;
  max-width: 228px;
}

@media (max-width: 959px) {
  .date-range__col--start,
  .date-range__col--end {
    flex: 0 0 50%;
    max-width: 50%;
    order: 1;
  }
}
</style>
